module.exports = __webpack_public_path__ + "img/inspiration_01@2x.5746664.webp";